export const VOICE_DASHBOARD_FETCH_STATS_REQUEST = 'VOICE_DASHBOARD_FETCH_STATS_REQUEST';
export const VOICE_DASHBOARD_FETCH_STATS_SUCCESS = 'VOICE_DASHBOARD_FETCH_STATS_SUCCESS';
export const VOICE_DASHBOARD_FETCH_STATS_ERROR = 'VOICE_DASHBOARD_FETCH_STATS_ERROR';

export const VOICE_DASHBOARD_FETCH_CALLS_REQUEST = 'VOICE_DASHBOARD_FETCH_CALLS_REQUEST';
export const VOICE_DASHBOARD_FETCH_CALLS_SUCCESS = 'VOICE_DASHBOARD_FETCH_CALLS_SUCCESS';
export const VOICE_DASHBOARD_FETCH_CALLS_ERROR = 'VOICE_DASHBOARD_FETCH_CALLS_ERROR';

export const VOICE_DASHBOARD_FETCH_TRANSCRIPT_REQUEST = 'VOICE_DASHBOARD_FETCH_TRANSCRIPT_REQUEST';
export const VOICE_DASHBOARD_FETCH_TRANSCRIPT_SUCCESS = 'VOICE_DASHBOARD_FETCH_TRANSCRIPT_SUCCESS';
export const VOICE_DASHBOARD_FETCH_TRANSCRIPT_ERROR = 'VOICE_DASHBOARD_FETCH_TRANSCRIPT_ERROR';

export const VOICE_DASHBOARD_SET_FILTERS = 'VOICE_DASHBOARD_SET_FILTERS';
export const VOICE_DASHBOARD_SET_PAGE = 'VOICE_DASHBOARD_SET_PAGE';
export const VOICE_DASHBOARD_CLEAR_TRANSCRIPT = 'VOICE_DASHBOARD_CLEAR_TRANSCRIPT';

export const VOICE_DASHBOARD_EXPORT_CSV_REQUEST = 'VOICE_DASHBOARD_EXPORT_CSV_REQUEST';
export const VOICE_DASHBOARD_EXPORT_CSV_SUCCESS = 'VOICE_DASHBOARD_EXPORT_CSV_SUCCESS';
export const VOICE_DASHBOARD_EXPORT_CSV_ERROR = 'VOICE_DASHBOARD_EXPORT_CSV_ERROR';

export const VOICE_DASHBOARD_SET_SELECTED_CALL = 'VOICE_DASHBOARD_SET_SELECTED_CALL';
export const VOICE_DASHBOARD_SET_CALLS_LOADING = 'VOICE_DASHBOARD_SET_CALLS_LOADING';



// WEBPACK FOOTER //
// ./src/containers/voice-agent-dashboard/store/types.js